const schema = "https://"
export default schema